module.exports = "../dist/frontend/icons/cards/section/card-white-map.svg?5af78bf817dec5c059f718b901323008";